import * as React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SidebarInset, SidebarProvider } from "ui/components/sidebar";
import MainSidebar from "./components/sidebar";
import { PermissionProvider } from "contexts/permission";
import { Separator } from "ui/components/separator";
import { UI_ACTION_PORTAL_ID } from "utils";
import { useEffect } from "react";
import { BreadcrumbNav } from "components/breadcrumb";
import { useRef } from "react";

export default function AppShell4({ ...props }) {
  const { pathname } = useLocation();

  const mainContentRef = useRef(null);
  useEffect(() => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname]);

  return (
    <PermissionProvider>
      <div className="w-full flex overflow-hidden max-h-dvh">
        <SidebarProvider
          name="main-sidebar"
          className="w-fit overflow-hidden max-h-dvh"
        >
          <MainSidebar {...props} />
        </SidebarProvider>
        <SidebarInset ref={mainContentRef} className="w-full relative">
          <header className="sticky z-50 top-0 w-full bg-white">
            <div className="flex justify-between bg-white  items-center px-4 h-12 md:h-16 shrink-0  transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12 border-b border-border">
              <div className="flex items-center gap-2">
                <Separator orientation="vertical" className="h-4" />
                <BreadcrumbNav />
              </div>
              <div
                id={UI_ACTION_PORTAL_ID}
                className="flex gap-4 items-center"
              />
            </div>
          </header>
          <div className="flex flex-1">
            <Outlet />
          </div>
        </SidebarInset>
      </div>
    </PermissionProvider>
  );
}
